/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: block;
}
:host .click-area {
  margin-bottom: 1.1428571429rem;
  align-items: center;
  overflow: hidden;
}
:host .click-area:hover .title {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host .click-area:hover #Shape {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host > .accordion {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host > .accordion .title {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host > .accordion div {
  flex: 0 0 auto;
}
:host > .accordion > .click-area {
  cursor: pointer;
  display: flex;
  flex-shrink: 1;
}
:host > .accordion > .click-area > svg {
  flex: 0 0 auto;
  height: 1.7142857143rem;
  width: 1.7142857143rem;
  cursor: pointer;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host > .accordion > .click-area > svg.active {
  transform: rotate(180deg);
}
:host > .accordion > .click-area > svg.prepend {
  order: -1;
}
:host > .panel {
  display: none;
}
:host > .panel.open {
  display: block;
}

:host([prepend-icon]) .title {
  margin-left: 0.8571428571rem;
}

:host(:not([prepend-icon])) svg {
  margin-left: 0.8571428571rem;
}

:host([open]) .title {
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}

:host(:focus-visible) {
  outline: none;
}
:host(:focus-visible) .click-area {
  outline: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
  outline-offset: 1px;
}

:host([hidden]) {
  display: none;
}

* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  border-bottom: 1px solid;
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-light, #C5CACC);
}
:host .click-area {
  width: 100%;
  margin-bottom: 0;
  padding: 1.1428571429rem 0.8571428571rem 1.1428571429rem 1.1428571429rem;
}
:host .click-area .title {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .click-area #Shape {
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}
:host .icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host .icon davinci-icon,
:host .icon davinci-icon-ref {
  margin-right: 0.8571428571rem;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
}
:host .click-area:hover .title {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .click-area:hover #Shape {
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}
:host .panel {
  padding: 0 1.1428571429rem 1.1428571429rem 1.1428571429rem;
}

:host([open]) .click-area .title {
  font-weight: bold;
}

:host(:hover) {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}

:host([open]:hover) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
}`;
export { style };
